import { css } from '@emotion/react';

export const MEDIA_MAX_HEIGHT = 150;

export const mediaContainerStyle = (messageOutbound: boolean) => css`
  display: flex;
  gap: var(--fabric-space-gap-xs);
  width: 100%;
  padding: var(--fabric-space-gap-xs);
  align-items: center;
  justify-content: ${messageOutbound ? 'flex-end' : 'flex-start'};
`;

export const previewContainerStyle = css`
  position: relative;
  max-width: 50%;
`;

export const extraCountOverlayStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: var(--fabric-radius-md);
`;

export const assetStyle = css`
  max-height: ${MEDIA_MAX_HEIGHT}px;
  object-fit: contain;
  border-radius: var(--fabric-radius-md);
`;
